/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Option_Day_YesterdayInputs */

const vi_lot_option_day_yesterday = /** @type {(inputs: Lot_Option_Day_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hôm qua`)
};

/**

* @param {Lot_Option_Day_YesterdayInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_option_day_yesterday = /** @type {((inputs?: Lot_Option_Day_YesterdayInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Option_Day_YesterdayInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_option_day_yesterday(inputs)
});